type VulnerabilityTemplateResponse {
  templates: [VulnerabilityTemplate!]
}

type VulnerabilityResponse {
  error: String!
  message: String!
  statusCode: Int
}

enum VulnerabilityProvider {
  COMENTIS
  ACRE
}

type VulnerabilityTemplate {
  id: ID!
  name: String!
  provider: VulnerabilityProvider!
}

type VulnerabilityReport {
  assessment_id: ID!
  external_url: String
  generated_at: String
  raw_categories: [String!]
  raw_vulnerabilities: [String!]
  report_detail: [VulnerabilityReportDetail!]
  report_id: String
  template_id: String
  title: String
  vulnerabilities: [VulnerabilityTag!]
}

type VulnerabilityReportDetail {
  indications: String
  linked_vulnerability: VulnerabilityTag
  risk_factor: String
}

type ClientVulnerabilityQuestion implements QuestionI {
  id: ID! # id holds the uuidv4 of the question entity.
  question: String # question is the question content
  version: Int # version is the version number of the entity in the blockchain
  type: QuestionType # type holds the type of the question
  event_trigger: QuestionEventTrigger # event_trigger is holding the event information
  choices: [String] # choices contains a list of choices of the question
  order: Int # order holds a random integer value used for ordering the questions
  required: Boolean # required represents if the user is required or not to answer the question
  topic: String # topic is the topic of the question
  answer: Answers # answer holds the answer of the question
  answered: Boolean # answered represents if the user has answered the question
  show_if: [DependencyCondition]
  is_numeric: Boolean
  lower_label: String
  upper_label: String
  min: Int
  max: Int
  step: Int
  ticks: Int
}

type ClientVulnerabilityQuestionResponse {
  assessment_uuid: ID!
  title: String
  intro: String
  progress: Int
  question: ClientVulnerabilityQuestion
}

input ClientVulnerabilityAnswerInput {
  assessment_uuid: ID!
  case_id: ID!
  question: SurveyQuestionInput!
  answer: AnswerInput!
}

